import { render } from "./ChartComponent.vue?vue&type=template&id=058d5f24&scoped=true&ts=true"
import script from "./ChartComponent.vue?vue&type=script&lang=ts"
export * from "./ChartComponent.vue?vue&type=script&lang=ts"

import "./ChartComponent.vue?vue&type=style&index=0&id=058d5f24&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058d5f24"]])

export default __exports__